import { render, staticRenderFns } from "./NotifRevamp.vue?vue&type=template&id=3db87538&"
import script from "./NotifRevamp.vue?vue&type=script&lang=js&"
export * from "./NotifRevamp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports